import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Container, Form, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane,
    FormFeedback } from 'reactstrap';
import classnames from "classnames";
import Flatpickr from "react-flatpickr";
import { ErrorBoundary } from 'react-error-boundary';

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
//import images
import AvatarSelector from './Avatar';
import progileBg from '../../../assets/images/profile-bg.jpg';
import EventBus from '../../../utils/eventBus'; // 引入 EventBus
import avatar1 from '../../../assets/images/users/avatar-1.jpg';

import { fetchProfileContent, postProfileContent, ProfilechangePassword, fetchLoginHistory, baseURL,selectAvatar } from '../../../utils/usermanagement';
import { addProfileImage } from '../../../utils/imageapi';
import { getBestProfilePhoto, getProfilePhotoWithFallback } from '../../../utils/profilePhotoUtils';
import { updateSessionStorageProfile, updateProfilePhoto, refreshProfileData, forceProfileRefresh } from '../../../utils/profileUpdateHelper';

import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";

// Error Boundary Fallback Component
const SettingsErrorFallback = ({ error, resetErrorBoundary }) => (
    <div className="page-content">
        <Container fluid>
            <div className="alert alert-danger" role="alert">
                <h4 className="alert-heading">Settings Loading Error</h4>
                <p>There was an issue loading the account settings. This might be a temporary problem.</p>
                <p className="mb-0">
                    <button className="btn btn-outline-danger btn-sm me-2" onClick={resetErrorBoundary}>
                        Try Again
                    </button>
                    <button className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>
                        Refresh Page
                    </button>
                </p>
            </div>
        </Container>
    </div>
);

const Settings = () => {
    const [activeTab, setActiveTab] = useState("1");
    const [text, setText] = useState("Hi I'm Anna Adame, It will be as simple as Occidental; in fact, it will be Occidental. To an English person, it will seem like simplified English, as a skeptical Cambridge friend of mine told me what Occidental is European languages are members of the same family.");
    const [textExperience, setTextExperience] = useState("You always want to make sure that your fonts work well together and try to limit the number of fonts you use to three or less. Experiment and play around with the fonts that you already have in the software you're working with reputable font websites. ");

    const tabChange = (tab) => {
        try {
            if (activeTab !== tab) {
                setActiveTab(tab);
            }
        } catch (error) {
            console.error('Error changing tab:', error);
            // Fallback to default tab
            setActiveTab("1");
        }
    };

    // Safe toggle wrapper for any toggle functions
    const safeToggle = (toggleFn, fallback = () => {}) => {
        return (...args) => {
            try {
                if (typeof toggleFn === 'function') {
                    return toggleFn(...args);
                } else {
                    console.warn('Toggle function is not a function:', toggleFn);
                    return fallback(...args);
                }
            } catch (error) {
                console.error('Error in safeToggle:', error);
                return fallback(...args);
            }
        };
    };
    
    const productState = [
    {
        options: [
        { label: "Select State...", value: "Select State" },
        { label: "Alabama", value: "Alabama" },
        { label: "Alaska", value: "Alaska" },
        { label: "American Samoa", value: "American Samoa" },
        { label: "California", value: "California" },
        { label: "Colorado", value: "Colorado" },
        { label: "District Of Columbia", value: "District Of Columbia" },
        { label: "Florida", value: "Florida" },
        { label: "Georgia", value: "Georgia" },
        { label: "Guam", value: "Guam" },
        { label: "Hawaii", value: "Hawaii" },
        { label: "Idaho", value: "Idaho" },
        { label: "Kansas", value: "Kansas" },
        { label: "Louisiana", value: "Louisiana" },
        { label: "Montana", value: "Montana" },
        { label: "Nevada", value: "Nevada" },
        { label: "New Jersey", value: "New Jersey" },
        { label: "New Mexico", value: "New Mexico" },
        { label: "New York", value: "New York" },
        ],
    },
    ];
    
    const productCountry = [
    {
        options: [
        { label: "Select Country...", value: "Select Country" },
        { label: "United States", value: "United States" },
        ],
    },
    ];
    
    const [role, setRole] = useState(null);
    const [profileData, setProfileData] = useState(null); 
    const [loginData, setLoginData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedAddressCity, setAddressCity] = useState(null);
    const [selectedState, setAddressState] = useState(null);
    const [selectedAddressCountry, setAddressCountry] = useState(null);
    const [avatarUrl, setAvatarUrl] = useState(null); // Store uploaded avatar URL
    const [profileImageUrl, setProfileImageUrl] = useState(null); // Store uploaded profile image URL
    
    // Function to get current profile photo source information
    const getProfilePhotoSourceInfo = () => {
        const userobj = JSON.parse(sessionStorage.getItem("user") || "{}");
        const apiProfileUrl = profileData?.profile_photo_url_object?.profile_url;
        const sessionPhotoUrl = userobj?.profile_photo_url_object?.profile_photo_fullurl;
        
        return {
            api_profile_url: apiProfileUrl,
            session_profile_photo_fullurl: sessionPhotoUrl,
            current_avatar: avatarUrl,
            current_profile_image: profileImageUrl,
            source: avatarUrl === sessionPhotoUrl ? 'sessionStorage' : 
                   avatarUrl === `${baseURL}/file/avatar/${apiProfileUrl}` ? 'API' :
                   avatarUrl.includes('/file/profile/image/') ? 'User Upload' :
                   avatarUrl.includes('/file/avatar/') ? 'Avatar Selection' : 'Default'
        };
    };
    const [isUploading, setIsUploading] = useState(false); // Track upload status
    const [showAvatarModal, setShowAvatarModal] = useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState(null);
    
    const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
    const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
    const getCurrentUser = () => {
        const userData = sessionStorage.getItem("user");
        return userData ? JSON.parse(userData) : null;
    };
    useEffect(() => {
        const handleReload = () => { 
            setRole(getCurrentUser()?.role); 
        }; 
        handleReload()
    }, []);  // 确保空依赖数组只执行一次

    function handleSelectAddressCity(value) {  
        setAddressCity(value);
    } 
    
    function handleSelectState(value) {
        setAddressState(value); 
    }
    
    function handleSelectAddressCountry(value) {  
        setAddressCountry(value);
    }
    
    const handleProfileImageUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
    
        setIsUploading(true);
        const formData = new FormData();
        formData.append("image", file);
    
        try {
          const response = await addProfileImage(formData);
          console.log('profile image response', response);

          if (response.filename) {
            const newAvatarUrl = `${baseURL}/file/profile/image/${response.filename}`;
            setAvatarUrl(newAvatarUrl);
            
            // Update profile data state
            setProfileData((prevData) => ({
                ...prevData,
                profile_photo_url_object: {
                    ...prevData.profile_photo_url_object,
                    profile_url: response.filename
                }
            }));
            
            console.log('Settings - Profile image upload successful, filename:', response.filename);
            
            // Update session storage with new profile photo
            const updatedUser = updateProfilePhoto('profile', response.filename, false);
            console.log('Settings - Session storage updated:', updatedUser);
            
            // Force refresh all profile components
            forceProfileRefresh();
            
            // Also refresh the profile data from API to ensure consistency
            setTimeout(async () => {
                console.log('Settings - Refreshing profile data from API...');
                await refreshProfileData(fetchProfileContent);
                console.log('Settings - Profile data refreshed from API');
            }, 100);
            
            console.log('Settings - Profile photo updated and session storage refreshed');
          }
        } catch (error) {
          console.error("Upload main image failed:", error);
        } finally {
          setIsUploading(false);
        }
    };

    // Handle avatar selection from the modal
    const handleAvatarSelect = async (avatarId,petId) => {
        console.log("Selected avatar ID:", avatarId);
        const response = await selectAvatar({"avatar_filename":avatarId,"pet_filename":petId});
        if (response.status == 200) {
            setSelectedAvatar(avatarId);
            const newAvatarUrl = `${baseURL}/file/avatar/${avatarId}`;
            setAvatarUrl(newAvatarUrl);
            
            // Update profile data state
            setProfileData((prevData) => ({
               ...prevData,
                avatar_url: avatarId,
                pet_url: petId,
                profile_photo_url_object: {
                    ...prevData.profile_photo_url_object,
                    profile_url: avatarId
                }
            })); 
            
            console.log('Settings - Avatar selection successful, avatarId:', avatarId, 'petId:', petId);
            
            // Update session storage with new avatar and pet
            const updatedUser = updateProfilePhoto('avatar', avatarId, false);
            console.log('Settings - Session storage updated for avatar:', updatedUser);
            
            if (petId) {
                const petUpdatedUser = updateProfilePhoto('pet', petId, false);
                console.log('Settings - Session storage updated for pet:', petUpdatedUser);
            }
            
            // Force refresh all profile components
            forceProfileRefresh();
            
            // Also refresh the profile data from API to ensure consistency
            setTimeout(async () => {
                console.log('Settings - Refreshing profile data from API after avatar update...');
                await refreshProfileData(fetchProfileContent);
                console.log('Settings - Profile data refreshed from API after avatar update');
            }, 100);
            
            // Close the modal
            setShowAvatarModal(false);
            
            // Show success notification
            successnotify("Avatar updated successfully!");
            
            console.log('Settings - Avatar updated and session storage refreshed');
        } 
        else {
            errornotify("Failed to update avatar."); 
        }
        
    };

    // Function to handle profile photo priority updates
    const updateProfilePhotoPriority = () => {
        const userobj = JSON.parse(sessionStorage.getItem("user") || "{}");
        const apiProfileUrl = profileData?.profile_photo_url_object?.profile_url;
        
        // Determine the best avatar URL based on priority
        let bestAvatarUrl = avatarUrl; // Keep current if it's user-uploaded
        
        // If no user-uploaded avatar, apply priority logic
        if (!avatarUrl || (!avatarUrl.includes('/file/profile/image/') && !avatarUrl.includes('/file/avatar/'))) {
            bestAvatarUrl = getProfilePhotoWithFallback(apiProfileUrl, 'avatar');
        }
        
        // Update avatar if it changed
        if (bestAvatarUrl !== avatarUrl) {
            setAvatarUrl(bestAvatarUrl);
            console.log('Settings - Avatar updated with priority logic:', {
                previous: avatarUrl,
                new: bestAvatarUrl,
                reason: 'Priority logic applied'
            });
        }
        
        return bestAvatarUrl;
    };
    
    // Function to refresh profile photos from sessionStorage
    const refreshProfilePhotosFromStorage = () => {
        const userobj = JSON.parse(sessionStorage.getItem("user") || "{}");
        
        // Check if we have updated profile data in session storage
        if (userobj && (userobj.profile_photo_url_object?.profile_url || userobj.profile_photo_url_object?.profile_photo_fullurl)) {
            // Get the best profile photo from session storage
            const bestPhoto = getBestProfilePhoto(userobj);
            
            // Only update if the photo has actually changed
            if (bestPhoto !== avatarUrl) {
                setAvatarUrl(bestPhoto);
                
                console.log('Settings - Profile photo updated from sessionStorage:', {
                    profile_url: userobj.profile_photo_url_object?.profile_url,
                    profile_photo_fullurl: userobj.profile_photo_url_object?.profile_photo_fullurl,
                    avatar_url: userobj.avatar_url,
                    profile_picture_url: userobj.profile_picture_url,
                    final_avatar_selection: bestPhoto,
                    reason: 'Profile photo changed in session storage'
                });
            }
        }
    };
    

    

    
    // Fetch profile data
    const navigate = useNavigate();
    useEffect(() => {
        const loadProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfileContent(); 
                if(response.status == 200) {   
                    setAddressCity(response.data.profile.location?.city);
                    setAddressCountry(response.data.profile.location?.country);
                    setAddressState(response.data.profile.location?.state);
                    setProfileData(response.data.profile);
                    setProfileImageUrl(
                        response.data.profile.profileImage
                            ? `${baseURL}/file/profile/image/${response.data.profile.profileImage}`
                            : getProfilePhotoWithFallback(null, 'profile')
                    );
                    setAvatarUrl(
                        getProfilePhotoWithFallback(
                            response.data.profile.profile_photo_url_object?.profile_url,
                            'avatar'
                        )
                    );
                    
                    console.log('Settings - Profile loaded with fallback logic:', {
                        api_profile_url: response.data.profile.profile_photo_url_object?.profile_url,
                        api_profileImage: response.data.profile.profileImage,
                        final_avatar: getProfilePhotoWithFallback(
                            response.data.profile.profile_photo_url_object?.profile_url,
                            'avatar'
                        ),
                        final_profile_image: response.data.profile.profileImage
                            ? `${baseURL}/file/profile/image/${response.data.profile.profileImage}`
                            : getProfilePhotoWithFallback(null, 'profile')
                    });
                    
                    // Apply priority logic after setting initial values
                    updateProfilePhotoPriority();
                } else {
                    errornotify(response.message);
                }
            } catch (error) {
                errornotify(error.message); 
            } finally {
                setIsLoading(false);
            }
        }; 
        loadProfileData();
        
        // Listen for storage changes (like after OAuth login)
        const handleStorageChange = () => {
            refreshProfilePhotosFromStorage();
        };
        
        // Listen for profile updates from other components
        const handleProfileUpdate = () => {
            console.log('Settings - Profile update event received, refreshing data');
            refreshProfilePhotosFromStorage();
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('profilePhotoUpdated', handleProfileUpdate);
        window.addEventListener('avatarUpdated', handleProfileUpdate);
        window.addEventListener('profileDataRefreshed', handleProfileUpdate);
        
        // Also check for profile photo updates periodically for first 10 seconds
        const interval = setInterval(refreshProfilePhotosFromStorage, 1000);
        
        setTimeout(() => {
            clearInterval(interval);
        }, 10000);
        
        // Initial refresh from sessionStorage
        refreshProfilePhotosFromStorage();
        
        // Listen for page visibility changes to refresh data when user returns to the page
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                console.log('Settings - Page became visible, refreshing profile data');
                refreshProfilePhotosFromStorage();
            }
        };
        
        document.addEventListener('visibilitychange', handleVisibilityChange);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('profilePhotoUpdated', handleProfileUpdate);
            window.removeEventListener('avatarUpdated', handleProfileUpdate);
            window.removeEventListener('profileDataRefreshed', handleProfileUpdate);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearInterval(interval);
        };
    }, []);
    
    //loading login history
    useEffect(() => {
        const loadLoginData = async () => {
            try {
                // const data = await fetchLoginHistory(); 
                // if (data){
                //     setLoginData(data);
                // } 
            } catch (error) {
                console.error("Error loading login history:", error); 
            }  
        }; 
        loadLoginData();
    }, []);

    const handleInputChange = (field, value) => {  
        setProfileData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        
        // Update session storage immediately for real-time updates
        const currentUser = JSON.parse(sessionStorage.getItem("user") || "{}");
        const updatedUser = {
            ...currentUser,
            [field]: value
        };
        sessionStorage.setItem("user", JSON.stringify(updatedUser));
        
        // Dispatch event to notify other components
        window.dispatchEvent(new CustomEvent('profileDataRefreshed', {
            detail: { profileData: { [field]: value }, updatedUser }
        }));
        
        console.log('Settings - Field updated in real-time:', field, value);
    };

    // handle form submit - includes all profile fields
    const handleSubmit = async (e) => {
        e.preventDefault();
      
        try { 
            const updatedProfileData = {
                ...profileData,
                location: {
                    city: selectedAddressCity,
                    country: selectedAddressCountry,
                    state: selectedState
                }
            };
            
            console.log('Settings - Submitting profile data:', updatedProfileData);
            
            await postProfileContent(updatedProfileData);
            successnotify("Profile updated successfully!");
            
            // Update session storage with the new profile data
            const updatedUser = updateSessionStorageProfile(updatedProfileData);
            console.log('Settings - Session storage updated with profile data:', updatedUser);
            
            // Refresh profile data from API and update session storage
            await refreshProfileData(fetchProfileContent);
            
            // Force refresh all profile components
            forceProfileRefresh();
            
            console.log('Settings - Profile updated and data refreshed');
        } catch (error) {
            console.error("Error updating profile:", error);
            errornotify("Failed to update profile.");
        }
    };

    // handle form submit [only 3 fields as demo]
    const handlechangePassword = async (values) => { 
        try {  
            const response = await ProfilechangePassword(values);
            if (response.status == 200) {  
                successnotify(response.data.message);
            } else { 
                errornotify(response.response.data.error);
            }
        } catch (err) {
            errornotify(err);
        }
    };
      
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true, 
        initialValues: {
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
        },
        validationSchema: Yup.object({
            oldPassword: Yup.string().required('Please Enter Your old password'),
            newPassword: Yup.string()
                .required('Please Enter Your new password')
                .test('passwords-match', 'The new password cannot be the same as the old password', function (value) { 
                return this.parent.oldPassword !== value;
                }),
            confirmPassword: Yup.string()
                .required("Please Enter Your confirm password")
                .oneOf([Yup.ref('newPassword')], 'The two passwords you entered do not match.'),
        }),
    });

    document.title = "Profile Settings | SeedNations";

    // CSS for the avatar modal
    const avatarModalStyles = `
        .avatar-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1050;
        }
        
        .avatar-modal {
            background-color: white;
            border-radius: 10px;
            width: 90%;
            max-width: 900px;
            max-height: 90vh;
            overflow: hidden;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
            display: flex;
            flex-direction: column;
        }
        
        .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 15px 20px;
            background-color: #2dd4bf;
            color: white;
            z-index: 9999;
        }
        
        .modal-header h3 {
            margin: 0;
            font-size: 20px;
        }
        
        .close-btn {
            background: none;
            border: none;
            color: white;
            font-size: 24px;
            cursor: pointer;
            line-height: 1;
        }
    `;

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <ToastContainer />
                    
                    {/* Loading State */}
                    {isLoading && (
                        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2 text-muted">Loading profile settings...</p>
                            </div>
                        </div>
                    )}
                    
                    {!isLoading && (
                    <>
                    {/* Avatar Modal */}
                    {showAvatarModal && (
                        <div className="avatar-modal-overlay">
                            <style>{avatarModalStyles}</style>
                            <div className="avatar-modal">
                                <div className="modal-header">
                                    <h3>Choose an Avatar</h3>
                                    <button 
                                        className="close-btn"
                                        onClick={() => setShowAvatarModal(false)}
                                    >×</button>
                                </div>
                                                                <ErrorBoundary
                                    fallback={
                                        <div className="alert alert-warning m-3">
                                            <p>Unable to load avatar selector. Please refresh the page.</p>
                                            <button 
                                                className="btn btn-secondary"
                                                onClick={() => setShowAvatarModal(false)}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    }
                                    onError={(error) => {
                                        console.error('Avatar Selector Error:', error);
                                    }}
                                >
                                    <AvatarSelector 
                                        onSelect={handleAvatarSelect} 
                                        onClose={() => setShowAvatarModal(false)}
                                    />
                                </ErrorBoundary>
                            </div>
                        </div>
                    )}
                    
                    <div className="position-relative mx-n4 mt-n4">
                        <div className="profile-wid-bg profile-setting-img">
                            <img src={progileBg} className="profile-wid-img" alt="" />
                            <div className="overlay-content">
                                <div className="text-end p-3">
                                    <div className="p-0 ms-auto rounded-circle profile-photo-edit">
                                        <Input id="profile-foreground-img-file-input" type="file"
                                            className="profile-foreground-img-file-input" />
                                        <Label htmlFor="profile-foreground-img-file-input"
                                            className="profile-photo-edit btn btn-light">
                                            <i className="ri-image-edit-line align-bottom me-1"></i> Change Cover
                                        </Label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Row>
                        <Col xxl={3}>
                            <Card className="mt-n5">
                                <CardBody className="p-4">
                                    <div className="text-center">
                                        <div className="profile-user position-relative d-inline-block mx-auto mb-4">
                                            <img 
                                                src={avatarUrl}
                                                className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                                alt="user-profile" 
                                            />
                                            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                                <Label 
                                                    htmlFor="profile-img-file-input"
                                                    className="profile-photo-edit avatar-xs"
                                                >
                                                    <span className="avatar-title rounded-circle bg-light text-body">
                                                        {isUploading ? (
                                                            <div className="spinner-border spinner-border-sm" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        ) : (
                                                            <i 
                                                                className="ri-camera-fill" 
                                                                onClick={() => setShowAvatarModal(true)}
                                                                style={{ cursor: 'pointer' }}
                                                            ></i>
                                                        )}
                                                    </span>
                                                </Label>
                                            </div>
                                        </div>
                                        <h5 className="fs-16 mb-1">
                                            {profileData?.firstName && profileData?.lastName 
                                                ? `${profileData.firstName} ${profileData.lastName}` 
                                                : profileData?.fullName || "No Name"}
                                        </h5>
                                        <p className="text-muted mb-0">{profileData?.role || ""}</p>


                                    </div>
                                </CardBody>
                            </Card> 
                        </Col>

                        <Col xxl={9}>
                            <Card className="mt-xxl-n5">
                                <CardHeader>
                                    <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                                        role="tablist">
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === "1" })}
                                                onClick={() => {
                                                    tabChange("1");
                                                }}>
                                                <i className="fas fa-home"></i>
                                                Personal Details
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink to="#"
                                                className={classnames({ active: activeTab === "2" })}
                                                onClick={() => {
                                                    tabChange("2");
                                                }}
                                                type="button">
                                                <i className="far fa-user"></i>
                                                Change Password
                                            </NavLink>
                                        </NavItem> 
                                    </Nav>
                                </CardHeader>
                                <CardBody className="p-4">
                                    <TabContent activeTab={activeTab}>
                                        <TabPane tabId="1">
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="firstnameInput" className="form-label">First
                                                                Name</Label>
                                                                <Input type="text" className="form-control" id="firstnameInput"
                                                                placeholder="Enter your firstname" value={profileData?.firstName || ""} 
                                                                onChange={(e) => handleInputChange("firstName", e.target.value)}/>
                                                        </div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="lastnameInput" className="form-label">Last
                                                                Name</Label>
                                                                <Input type="text" className="form-control" id="lastnameInput"
                                                                placeholder="Enter your lastname" value={profileData?.lastName || ""}
                                                                onChange={(e) => handleInputChange("lastName", e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="phonenumberInput" className="form-label">Phone
                                                                Number</Label>
                                                                <Input type="text" className="form-control"
                                                                id="phonenumberInput"
                                                                placeholder="Enter your phone number"
                                                                value={profileData?.phone || ""}
                                                                onChange={(e) => handleInputChange("phone", e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="emailInput" className="form-label">Email
                                                                Address</Label>
                                                            <Input type="email" className="form-control" id="emailInput"
                                                                placeholder="Enter your email"
                                                                defaultValue="daveadame@velzon.com"  
                                                                value={profileData?.email || ""}
                                                                onChange={(e) => handleInputChange("email", e.target.value)} /> 
                                                        </div>
                                                    </Col> 
                                                    
                                                    {role?.includes('employee') ?<>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="companyInput" className="form-label">Company</Label>
                                                           <div>{profileData?.company || ""}</div>
                                                        </div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="Position" className="form-label">Position</Label>
                                                            <Input type="text" className="form-control" id="Position"
                                                                placeholder="Enter your Position" value={profileData?.position || ""}
                                                                onChange={(e) => handleInputChange("position", e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="jobtitleInput" className="form-label">Department</Label>
                                                            <Input type="text" className="form-control" id="department"
                                                                placeholder="Enter your Department" value={profileData?.department || ""}
                                                                onChange={(e) => handleInputChange("department", e.target.value)} />
                                                        </div>
                                                    </Col>
                                                    
                                                    <Col lg={6}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="manager" className="form-label">Manager</Label>
                                                        <div> {profileData?.manager_list ? profileData.manager_list.map(manager => 
                                                                                                `${manager.first_name} ${manager.last_name}`
                                                                                            ).join(', ') 
                                                                                        : ""}</div>   
                                                        </div>
                                                    </Col>
                                                    </>:""}
                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="CityInput" className="form-label">
                                                            City</Label>
                                                            <Input  className="form-control" id="cityInput"
                                                                placeholder="Enter your city" 
                                                                value={selectedAddressCity || ""}
                                                                onChange={(e) => handleSelectAddressCity(e.target.value)} /> 
                                                                
                                                        </div>
                                                    </Col> 
                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="stateInput" className="form-label">
                                                            State </Label>
                                                            <Select
                                                                value={{ value: selectedState, label: selectedState }}
                                                                onChange={(e) => {
                                                                handleSelectState(e.value);
                                                                }}  
                                                                options={productState}
                                                                name="state"
                                                                classNamePrefix="select2-selection form-select"
                                                            />  
                                                        </div>
                                                    </Col> 
                                                    <Col lg={4}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="cityInput" className="form-label">
                                                            Country </Label>
                                                            <Select
                                                                value={{ value: selectedAddressCountry, label: selectedAddressCountry }}
                                                                onChange={(e) => {
                                                                handleSelectAddressCountry(e.value);
                                                                }}  
                                                                options={productCountry}
                                                                name="country"
                                                                classNamePrefix="select2-selection form-select"
                                                            />  
                                                        </div>
                                                    </Col> 
                                                    <Col lg={12}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="aboutInput" className="form-label">About</Label>
                                                            <textarea
                                                            className="form-control"
                                                             id="about" 
                                                            name="about"
                                                            rows="3"
                                                            value={profileData?.about || ""} 
                                                            onChange={(e) => handleInputChange("about", e.target.value)}
                                                            ></textarea> 
                                                        </div>
                                                    </Col> 
                                                    <Col lg={12}>
                                                        <div className="hstack gap-2 justify-content-end">
                                                            <button type="submit"
                                                                className="btn btn-primary">Updates</button>
                                                            <Link type="button"  to="/profile"
                                                                className="btn btn-soft-secondary">Cancel</Link>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane>

                                        <TabPane tabId="2">
                                                <Form
                                                    onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handlechangePassword(validation.values);
                                                    return false;
                                                    }}
                                                >
                                                <Row className="g-2">
                                                    <Col lg={4}>
                                                        <div>
                                                            <Label htmlFor="oldpasswordInput" className="form-label">Old
                                                                Password*</Label>
                                                                <Input
                                                                name="oldPassword"
                                                                className="form-control"
                                                                placeholder="Enter oldPassword"
                                                                type="password"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.oldPassword || ""} 
                                                                /> 
                                                        </div>
                                                    </Col>

                                                    <Col lg={4}>
                                                        <div>
                                                            <Label htmlFor="newpasswordInput" className="form-label">New
                                                                Password*</Label>
                                                                <Input
                                                                name="newPassword"
                                                                className="form-control"
                                                                placeholder="Enter newPassword"
                                                                type="password"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.newPassword || ""}
                                                                invalid={
                                                                    validation.touched.newPassword && validation.errors.newPassword ? true : false
                                                                }
                                                                />
                                                                {validation.touched.newPassword && validation.errors.newPassword ? (
                                                                <FormFeedback type="invalid"><div>{validation.errors.newPassword}</div></FormFeedback>
                                                                ) : null}
                                                        </div>
                                                    </Col>

                                                    <Col lg={4}>
                                                        <div>
                                                            <Label htmlFor="confirmpasswordInput" className="form-label">Confirm
                                                                Password*</Label>
                                                                <Input
                                                                name="confirmPassword"
                                                                className="form-control"
                                                                placeholder="Enter confirmPassword"
                                                                type="password"
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.confirmPassword || ""}
                                                                invalid={
                                                                    validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                                                                }
                                                                />
                                                                {validation.touched.confirmPassword && validation.errors.confirmPassword ? (
                                                                <FormFeedback type="invalid"><div>{validation.errors.confirmPassword}</div></FormFeedback>
                                                                ) : null}
                                                        </div>
                                                    </Col>

                                                    <Col lg={12}>
                                                        <div className="mb-3">
                                                            <Link to="/forgot-password"
                                                                className="link-primary text-decoration-underline">Forgot
                                                                Password ?</Link>
                                                        </div>
                                                    </Col>

                                                    <Col lg={12}>
                                                        <div className="text-end">
                                                            <button type="submit" className="btn btn-primary">Change
                                                                Password</button>
                                                        </div>
                                                    </Col>

                                                </Row>

                                            </Form>
                                            <div className="mt-4 mb-3 border-bottom pb-2">
                                                <div className="float-end">
                                                    <Link to="#" className="link-secondary">All Logout</Link>
                                                </div>
                                                <h5 className="card-title">Login History</h5>
                                            </div>
                                            {loginData ? loginData.map((item, key) => (
                                                <div className="d-flex align-items-center mb-3" key={key}>
                                                    <div className="flex-shrink-0 avatar-sm">
                                                        <div className="avatar-title bg-light text-primary rounded-3 fs-18">
                                                            <i className="ri-smartphone-line"></i>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h6>{item.device}</h6>
                                                        <p className="text-muted mb-0">{item.content}</p>
                                                    </div>
                                                    <div>
                                                        <Link to="#">Logout</Link>
                                                    </div>
                                                </div>
                                            )) : ""} 
                                        </TabPane> 
                                    </TabContent>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    </>
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};

// Wrap the entire Settings component with ErrorBoundary
const SafeSettings = () => (
    <ErrorBoundary
        FallbackComponent={SettingsErrorFallback}
        onError={(error, errorInfo) => {
            console.error('Settings Component Error:', error, errorInfo);
        }}
    >
        <Settings />
    </ErrorBoundary>
);

export default SafeSettings;